import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';

import { RequireAuth } from '@/components/RequireAuth';
import { TooltipProvider } from '@/components/ui/Tooltip';
import { AuthProvider } from '@/contexts/AuthContext';
import { PlayerProvider } from '@/contexts/PlayerContext';
import { BrowsePage } from '@/pages/BrowsePage';
import { LoginPage } from '@/pages/LoginPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AuthProvider>
          <PlayerProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route element={<RequireAuth />}>
                  <Route path="/browse" element={<BrowsePage />} />
                </Route>
                <Route path="/" element={<Navigate to="/browse" replace />} />
                <Route path="*" element={<Navigate to="/browse" replace />} />
              </Routes>
            </BrowserRouter>
            <Toaster
              theme="dark"
              position="bottom-right"
              toastOptions={{
                className: 'border border-border bg-surface text-text text-xs',
              }}
            />
          </PlayerProvider>
        </AuthProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
